<template >
  <v-sheet
    style="background: white"
    class="fill-height d-flex justify-space-around"
  >
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-overlay opacity="0">
      <v-card v-if="!successful" style="max-width: 350px" color="white" elevation="0" class="mt-0">
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          Create New Password.
        </h5>
        <v-form fluid ref="form" v-model="valid" lazy-validation name="form">
          <v-container>
            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-lock"
              v-model="match"
              type="password"
              label="New Password"
              outlined
              required
              :rules="confirmPasswordRules"
            ></v-text-field>

            <v-text-field
              light
              color="#2A353D"
              prepend-inner-icon="mdi-lock"
              v-model="newPassword"
              type="password"
              label="Confirm Password"
              outlined
              required
              :rules="newPasswordRules"
            ></v-text-field>

            <v-btn v-if="!successful" :disabled="!valid" @click="loading = true; updatePassword()" class="btn btn-primary btn-block" color="#2A353D">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              <span class="white--text font-weight-bold">Submit</span>
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
      <v-card v-else style="max-width: 350px" color="white" elevation="0" class="mt-0">
        <v-img
          class="mt-0"
          src="../assets/flat.png"
          height="200"
          contain
          >
        </v-img>
        <h5 class="text-center subtitle-1 grey--text font-weight-normal">
          Password created successfully
        </h5>
        <v-btn class="mt-12" color="#2A353D" block @click="$router.push('/login')">GO TO LOGIN</v-btn>
      </v-card>
    </v-overlay>
  </v-sheet>
</template>

<script>
import {mapGetters} from 'vuex';
import decodeService from '../services/decode.service';
import userManagementService from '../services/userManagement.service';

export default {

  data() {
    return {
      newPassword: '',
      currentPassword: '',
      loading: false,
      match: '',
      message: '',
      valid: true,
      successful: false,

      currentPasswordRules: [
        v => !!v || 'current password is required',
      ],
      newPasswordRules: [
        v => !!v || 'confirm your new password',
        v => (!!v && v) === this.match || 'Passwords do not match'
      ],
      confirmPasswordRules: [
        v => !!v || 'new password required',
        v => (v && v.length >= 6) || 'password must be at least 6 characters',
        v => !this.allInvalidPasswords.map(a => a.Password).includes(v) || 'This password is flagged, choose another password'
      ],
    };
  },

  computed: {
    ...mapGetters([
      "allInvalidPasswords"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },

  created() {
    if (this.loggedIn) {
      this.$router.push('/home');
    }
  },

  methods: {
    async updatePassword () {
      this.message = '';
      decodeService.decodeEmailToken(this.$route.params.token)
      .then(async response => {
        await this.validate();
        if(this.valid == true){

          var data = {
            Password: this.newPassword
          }

          userManagementService.changePassword(response.data.decoded.SecurityUserID, data)
          .then(response => {
            this.message = response.data.message;
            this.successful = true;
            this.reset()
            // this.close()
          },
          error => {
            this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.successful = false;
          })
        }
      },
      error => {
        this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false
      })
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },
  },
};
</script>

<style scoped>

#ChangePwd {
  background-color: white;
}

.text {
  color: #1C284E;
}

.v-btn {
  outline: none
}

</style>